module.exports = __webpack_public_path__ + "static/media/Memb-I-00131_0015.6410960c.jpg";